import styled from 'styled-components';
import Button from 'ui/Button/Button';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import Title from 'ui/Typography/Title';
import Body from 'ui/Typography/Body';
import image from './error.png';
import { isMobile } from 'utils/platform';

const Fullscreen = styled.div`
  position: absolute;
  inset: 0;
  background: ${({ theme }) => theme.colors.white};
  z-index: 10000;
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  gap: ${({ theme }) => (isMobile() ? theme.space.l : theme.space.xxl)};
  flex-wrap: wrap-reverse;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 ${({ theme }) => (isMobile() ? theme.space.l : theme.space.xxxxl)};
`;

const MessageWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  max-width: 500px;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.l};
`;

const Image = styled.img`
  max-width: min(500px, 100%);
`;

export type FallbackProps = {
  title: string;
  body: React.ReactNode;
  button?: string;
  onClick?: React.ComponentProps<typeof Button>['onClick'];
  fullscreen?: boolean;
};

const FallbackContent = ({ title, body, button, onClick }: FallbackProps) => {
  return (
    <Wrapper>
      <MessageWrapper>
        <Title
          mt="md"
          type={
            isMobile() ? ThemeFontStyleTypeEnum.headingMedium : ThemeFontStyleTypeEnum.headingLarge
          }
        >
          {title}
        </Title>
        <Body mb="md" type={ThemeFontStyleTypeEnum.bodyMedium}>
          {body}
        </Body>
        {button && (
          <Button
            onClick={onClick}
            style={{ width: '100%' }}
            type="primary"
            size={isMobile() ? 'small' : 'medium'}
          >
            {button}
          </Button>
        )}
      </MessageWrapper>
      <Image src={image} />
    </Wrapper>
  );
};

const Fallback: typeof FallbackContent = ({ fullscreen, ...props }) => {
  if (fullscreen) {
    return (
      <Fullscreen>
        <FallbackContent {...props} />
      </Fullscreen>
    );
  }

  return <FallbackContent {...props} />;
};

export default Fallback;
